'use strict';

require('../../company/blogs/CompanyMessageService.js');
require('../../company/comments/CompanyCommentsService.js');
require('../../company/publications/CompanyUserLinksCtrl.js');
require('../../app/ReloadUserRoleDashboard.js');
function CompanyGuestPublicationsCtrl(
  $scope,
  $stateParams,
  $state,
  $modal,
  $window,
  reloadUserRoleDashboard,
  userInformation,
  CompanyMessageService,
  CompanyCommentsService,
  CompanyTaskService,
  CompanyPublicationService,
  notices
  ) {
  $scope.userInfo = userInformation;
  $scope.posts = [];
  $scope.comments = [];
  $scope.latestTasks = [];
  $scope.notices = notices;
  $scope.state = $state;
  $scope.$on('$stateChangeSuccess', function(){
    if ($state.current.name === 'root.company-guest.publications') {
      reloadUserRoleDashboard.reload();
    }
  });

  $scope.$on('$stateChangeStart', function(){
    reloadUserRoleDashboard.stop();
  });
  
  setTimeout(function(){
    var options = {
      alwaysShowResizeHandle: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      disableOneColumnMode: true
    };
    jQuery('.grid-stack').gridstack(options);
  }, 10);

  angular.element($window).on('resize', function () {
    var widthWindowH = angular.element($window).width();
    var grid = jQuery('.grid-stack').data('gridstack');
    if(widthWindowH < 1016 && widthWindowH > 825){
      angular.forEach($scope.role.template.data, function(value, key){
        grid.update(jQuery(".grid-stack-item:nth-child("+(key+1)+")"), (value.chartData.gsX === "0" ? 0 : 6), value.chartData.gsY, 6, value.chartData.gsHeigth);
      });
    }else{
      if(widthWindowH >= 1016){
        angular.forEach($scope.role.template.data, function(value, key){
          grid.update(jQuery(".grid-stack-item:nth-child("+(key+1)+")"), parseInt(value.chartData.gsX), parseInt(value.chartData.gsY), parseInt(value.chartData.gsWidth), parseInt(value.chartData.gsHeigth));
        });
      }else{
        angular.forEach($scope.role.template.data, function(value, key){
          grid.update(jQuery(".grid-stack-item:nth-child("+(key+1)+")"), 0, parseInt(value.chartData.gsY), 12, parseInt(value.chartData.gsHeigth));
        });
      }
    }
  });

  if ($scope.role !==  null && $scope.role.template) {
    var gsYMax = 0;
    var gsHeigthMax = 4;
    if($scope.role.template.data){
      angular.forEach($scope.role.template.data, function(value, key){
        value.chartData = value.chartData ? value.chartData : {};
        value.chartData.gsX = angular.isDefined(value.chartData.gsX) ? value.chartData.gsX : (key%3===0 ? 0 : (key%3===1 ? 4 : 8));
        value.chartData.gsY = angular.isDefined(value.chartData.gsY) ? value.chartData.gsY : 0;
        value.chartData.gsWidth = angular.isDefined(value.chartData.gsWidth) ? value.chartData.gsWidth : 4;
        value.chartData.gsHeigth = angular.isDefined(value.chartData.gsHeigth) ? value.chartData.gsHeigth : 7;
        if(parseInt(value.chartData.gsY) > gsYMax){
          gsYMax = parseInt(value.chartData.gsY);
          gsHeigthMax = parseInt(value.chartData.gsHeigth);
        }
      });
    }
    var boxMessage = $scope.role.template.data.filter(function(d){ return d.columnType === 'MESSAGE'; });
    if ($scope.info.features.blogs && $scope.role.showMessage) {
      CompanyMessageService.query({
        companyId: $stateParams.companyId,
        limit: 4,
        showInList: false
      }, function(resp){
        $scope.posts = resp;
        if(!boxMessage[0]){
          if($scope.posts.length > 0){
            $scope.role.template.data.push({
              isChart: false,
              centralInformation: false,
              columnType: 'MESSAGE',
              isFullBox: false,
              chartData: {
                gsX: 0,
                gsY: gsYMax+gsHeigthMax,
                gsWidth: 4,
                gsHeigth: 4,
              }
            });
          }
        }else{
          if($scope.posts.length === 0){
            $scope.role.template.data.splice($scope.role.template.data.indexOf(boxMessage[0]), 1);
          }
        }
      }, function(){
        if(boxMessage[0]){
          $scope.role.template.data.splice($scope.role.template.data.indexOf(boxMessage[0]), 1);
        }
      });
    }else{
      if(boxMessage[0]){
        $scope.role.template.data.splice($scope.role.template.data.indexOf(boxMessage[0]), 1);
      }
    }

    var boxComment = $scope.role.template.data.filter(function(d){ return d.columnType === 'COMMENT'; });
    if ($scope.role.showComment) {
      CompanyCommentsService.queryComments({
        companyId: $stateParams.companyId,
        limit: 4
      }, function(resp){
        $scope.comments = resp;
        if(!boxComment[0]){
          if($scope.comments.length > 0){
            $scope.role.template.data.push({
              isChart: false,
              centralInformation: false,
              columnType: 'COMMENT',
              isFullBox: false,
              chartData: {
                gsX: 0,
                gsY: gsYMax+gsHeigthMax,
                gsWidth: 4,
                gsHeigth: 4,
              }
            });
          }
        }else{
          if($scope.comments.length === 0){
            $scope.role.template.data.splice($scope.role.template.data.indexOf(boxComment[0]), 1);
          }
        }
      }, function(){
        if(boxComment[0]){
          $scope.role.template.data.splice($scope.role.template.data.indexOf(boxComment[0]), 1);
        }
      });

      $scope.$on('notification', function(e, data) {
        if (data.type === 'COMMENT') {
            var c = {
              id: data.message.id,
              text: data.message.text,
              createdAt: (new Date()).toISOString(),
              createdBy:      data.sourceUser,
              objectRelative: data.publication
            };
            $scope.$apply(function(){
              if(data.message.parentID === 'undefined'){
                if ($scope.comments.length === 4) {
                  $scope.comments.splice($scope.comments.length - 1, 1);
                }
                $scope.comments.unshift(c);
              }else{
                angular.forEach($scope.comments, function(item){
                  if(item.id === data.message.parentID){
                    if(!item.commentChild){
                      item.commentChild = [];
                    }
                    item.commentChild.push(c);
                  }
                });
              }
            });
        }
      });
    }else{
      if(boxComment[0]){
        $scope.role.template.data.splice($scope.role.template.data.indexOf(boxComment[0]), 1);
      }
    }
      
    var boxReminder = $scope.role.template.data.filter(function(d){ return d.columnType === 'REMINDER'; });
    if ($scope.info.features.reminders && $scope.role.showReminder) {
      CompanyTaskService.query({companyId: $stateParams.companyId, status: 'INCOMPLETE', limit: 4}).$promise.then(function(resp){
        $scope.latestTasks = resp;
        if(!boxReminder[0]){
          if($scope.latestTasks.length > 0){
            $scope.role.template.data.push({
              isChart: false,
              centralInformation: false,
              columnType: 'REMINDER',
              isFullBox: false,
              chartData: {
                gsX: 0,
                gsY: gsYMax+gsHeigthMax,
                gsWidth: 4,
                gsHeigth: 4,
              }
            });
            setTimeout(function(){
              var grid = jQuery('.grid-stack').data('gridstack');
              grid.addWidget(jQuery('.grid-stack-item:last-child'), 0, yMax+heigthMax, 4, 4, true);
            }, 1000);
          }
        }else{
          if($scope.latestTasks.length === 0){
            $scope.role.template.data.splice($scope.role.template.data.indexOf(boxReminder[0]), 1);
          }
        }
      }, function(){
        if(boxReminder[0]){
          $scope.role.template.data.splice($scope.role.template.data.indexOf(boxReminder[0]), 1);
        }
      });
    }else{
      if(boxReminder[0]){
        $scope.role.template.data.splice($scope.role.template.data.indexOf(boxReminder[0]), 1);
      }
    }
    
    if($scope.role.template !==  null) {
      $scope.userLinks = angular.isDefined(userInformation.features.userLinks) ? userInformation.features.userLinks : [];
    }

    $scope.checkColors = function(xAxesDisplay){
      if($scope.role.template && $scope.role.template.id){
        angular.forEach($scope.role.template.data, function(v, k){
          if(v.isChart && v.chartData){
            if(v.chartData.type === 'line-bar'){
              $scope.role.template.data[k].options = {
                legend: { 
                  display: true , 
                  position: 'bottom'
                },
                scales: {
                  xAxes: [{
                    ticks: {
                      display: true
                    }
                  }],
                  yAxes: []
                }
              };
              
              if(xAxesDisplay <= 483){
                $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
              }else{
                if(xAxesDisplay < 999){
                  if(xAxesDisplay > 807){
                    if($scope.role.template.id === '5' || $scope.role.template.id === '6'){
                      if(k === 0){
                        $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
                      }else{
                        if($scope.role.template.id === '6'){
                          $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
                        }else{
                          $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
                        }
                      }
                    }else{
                      $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
                    }
                  }else{
                    $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
                  }
                }else{
                  if((($scope.role.template.id === '5' || $scope.role.template.id === '6') && k === 0) || !v.isFullBox){
                    $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
                  }
                }
              }
            }else{
              $scope.role.template.data[k].options = { 
                legend: { 
                  display: true, 
                  position: 'bottom'
                }
              };
              if(v.chartData.type === 'bar' || v.chartData.type === 'line'){
                $scope.role.template.data[k].options = { 
                  legend: { 
                    display: true, 
                    position: 'bottom'
                  },
                  scales: {
                    xAxes: [{
                      ticks: {
                        display: true
                      }
                    }]
                  } 
                };
                
                if(xAxesDisplay <= 483){
                  $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
                }else{
                  if(xAxesDisplay < 999){
                    if(xAxesDisplay > 807){
                      if($scope.role.template.id === '5' || $scope.role.template.id === '6'){
                        if(k === 0){
                          $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
                        }else{
                          if($scope.role.template.id === '6'){
                            $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
                          }else{
                            $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
                          }
                        }
                      }else{
                        $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
                      }
                    }else{
                      $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = true;
                    }
                  }else{
                    if((($scope.role.template.id === '5' || $scope.role.template.id === '6') && k === 0) || !v.isFullBox){
                      $scope.role.template.data[k].options.scales.xAxes[0].ticks.display = false;
                    }
                  }
                }
              }
            }
            if(v.chartData.type !== 'doughnut' && v.chartData.type !== 'pie'){
              $scope.role.template.data[k].datasetOverride = [];
              angular.forEach(v.chartData.colors, function(value, key){
                if(v.chartData.type === 'line-bar'){
                  $scope.role.template.data[k].datasetOverride.push({
                    yAxisID: 'y-axis-'+(key+1),
                    borderWidth: key === 0 ? 2 : 1,
                    backgroundColor: key === 0 ? 'transparent' : value,
                    pointBackgroundColor: key === 0 ? 'transparent' : value,
                    borderColor: value,
                    pointBorderColor: value,
                    type: key === 0 ? 'line' : 'bar'
                  });
                  $scope.role.template.data[k].options.scales.yAxes.push({
                    id: 'y-axis-'+(key+1),
                    display: true,
                    position: key === 0 ? 'left' : 'right'
                  });
                }else{
                  $scope.role.template.data[k].datasetOverride.push({
                    borderWidth: v.chartData.type === 'line' ? 2 : 1,
                    backgroundColor: v.chartData.type === 'line' ? 'transparent' : value,
                    pointBackgroundColor: v.chartData.type === 'line' ? 'transparent' : value,
                    borderColor: value,
                    pointBorderColor: value
                  });
                }
              });
            }
          }
        });
      }
    };

    var widthWindow = angular.element($window).width();
    $scope.checkColors(widthWindow);
    angular.element($window).on('resize', function () {
      widthWindow = angular.element($window).width();
      $scope.$apply(function(){
        $scope.checkColors(widthWindow);
      });
    });

    $scope.getBlogLastest = function(data){
      if(data.columnType === 'BLOG' && (data.columnData.object || data.columnData.blogId)){
        var index = $scope.role.template.data.indexOf(data);
        CompanyPublicationService.getPostLastest({
          companyId: $stateParams.companyId,
          publicationId: (data.columnData.object ? data.columnData.object.id : data.columnData.blogId),
          only: data.columnData.only,
          limit: (data.columnData.showThreePosts ? 3 : 1)
        }, function(resp){
          $scope.role.template.data[index].blogLastest = resp;
        });
      }
    };
  }

  $scope.showModalUserLink = function(link, index) {
    $modal({
      scope: $scope,
      controller: 'CompanyUserLinksCtrl',
      templateUrl: 'partials/company/publications/lists/user-link.html',
      show: true,
      resolve: {
        link: function() {
          return link || false;
        },
        index: function() {
          return (angular.isUndefined(index) ? -1 : index);
        }
      }
    });
  };
}


CompanyGuestPublicationsCtrl.resolve = {
  userInformation: ['$stateParams', 'CompanyUserService', '$window', function($stateParams, CompanyUserService, $window){
    return CompanyUserService.get({companyId: $stateParams.companyId, userId: $window.localStorage.userId}).$promise;
  }],
  notices: ['CompanyService', function(CompanyService){
    return CompanyService.queryNotices().$promise;
  }]
};

module.exports = CompanyGuestPublicationsCtrl;

angular.module('dokiv')
  .controller('CompanyGuestPublicationsCtrl', [
    '$scope',
    '$stateParams',
    '$state',
    '$modal',
    '$window',
    'reloadUserRoleDashboard',
    'userInformation',
    'CompanyMessageService',
    'CompanyCommentsService',
    'CompanyTaskService',
    'CompanyPublicationService',
    'notices',
    CompanyGuestPublicationsCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/publications/CompanyGuestPublicationsCtrl.js
// module id = 299
// module chunks = 0